import { UserInfoModel } from "app/model/ua/user-info";
import { useAppSelector } from "app/store/hook";
import DbUserTitle from "app/pages/db/user/DbUserTitle";
import ActivityLog from "app/pages/db/modules/ActivityLog";
import ActivityFeed from "app/pages/db/modules/ActivityFeed";
import NoticeNews from "app/pages/db/modules/NoticeNews";
import React from "react";
import SmpStatistics from "app/pages/db/modules/SmpStatistics";
import SaleDesc from "app/pages/db/modules/SaleDesc";
import BrokerTrdPrcnd from "app/pages/db/broker/BrokerTrdPrcnd";

export default function DbBrokerBase() {
  const userInfo: UserInfoModel = useAppSelector(state => state.userInfo.userInfo);

  return (
    <>
      {userInfo?.userId && (
        <div className="container">
          <div className="dashboard-wrap">
            <DbUserTitle title="메인(To do list)"/>
            <div className="col-wrap">
              <BrokerTrdPrcnd />
              <SaleDesc />
            </div>
            <div className="col-wrap">
              <ActivityLog/>
              <ActivityFeed/>
            </div>
            <div className="col-wrap">
              <NoticeNews/>
              <SmpStatistics/>
            </div>
          </div>
        </div>
      )}
    </>
  );
}